import {Alert, Table} from "react-bootstrap";
import {Link} from "react-router";
import {ProfileApi} from "../../api/ProfileApi";
import {useAsync} from "../../components/useAsync";
import {ErrorAlert} from "../../components/ErrorAlert";
import {LoadingSpinner} from "../../components/LoadingSpinner";
import {PageHeader} from "../../components/PageHeader";
import {formatDate, formatPrice} from "../../components/format";
import {OrderStatusBadge, providerName} from "./OrderParts";
import {TrademarkNoticesFor} from "../../components/TrademarkNotices";
import {account, format, rich} from "../../i18n";

// The user's purchases (the receipt email links here). The licenses themselves are on My licenses.
export function MyOrdersPage() {
    const {data: orders, error, loading} = useAsync(() => ProfileApi.orders(), []);
    const c = account.orders.columns;
    return (
        <>
            <PageHeader title={account.orders.title}/>
            {loading && !orders && <LoadingSpinner/>}
            <ErrorAlert error={error}/>
            {orders?.length === 0 && <Alert variant="secondary">{rich(account.orders.none, { link: text => <Link to="/products">{text}</Link> })}</Alert>}
            {!!orders?.length && (
                <Table responsive>
                    <thead>
                    <tr><th>{c.date}</th><th>{c.order}</th><th>{c.product}</th><th>{c.licensedTo}</th><th className="text-end">{c.total}</th><th>{c.paidWith}</th><th>{c.status}</th></tr>
                    </thead>
                    <tbody>
                    {orders.map(order => (
                        <tr key={order.id}>
                            <td>{formatDate(order.createdOn)}</td>
                            <td className="small font-monospace">{order.id}</td>
                            <td>{format(account.orders.product, { product: order.productName, edition: order.edition })}</td>
                            <td>{order.licensee}</td>
                            <td className="text-end">{formatPrice(order.total, order.currency)}</td>
                            <td>{providerName(order.provider)}</td>
                            <td><OrderStatusBadge status={order.status}/></td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            )}
            <p className="small text-body-secondary">
                {rich(account.orders.footer, { link: text => <Link to="/account/licenses">{text}</Link>, ticket: text => <Link to="/support/new">{text}</Link> })}
            </p>
            {!!orders?.length && <TrademarkNoticesFor skus={orders.map(x => x.productSku)} className="mt-5"/>}
        </>
    );
}
